/**
 * 导入HTTP请求工具和基础API地址
 * @module api/account
 */
import axios from '@/api/config/request' // 导入axios HTTP请求工具
import { BASE_API } from './index'

// 账号校验(手机号)
export function checkMobile(mobile) {
  return axios({
    url: `${BASE_API}/account/check/mobile?acct=${mobile}`,
    method: 'get'
  })
}
// 账号注册(手机号验证码 ）
export function registryByMobile(data) {
  return axios({
    url: `${BASE_API}/account/registry/mobile`,
    method: 'post',
    data
  })
}

/**
 * 激活账号
 * @param {Object} data - 激活账号所需的请求数据
 * @param {string} data.mobile - 用户手机号
 * @param {string} data.code - 短信验证码
 * @returns {Promise} 返回axios请求的Promise对象
 */
export function activeAccount(data) {
  return axios({
    url: `${BASE_API}/account/active`,
    method: 'put',
    data
  })
}
/**
 * 获取登录用户信息
 * @returns {Promise} 返回axios请求的Promise对象
 */
export function getAccountInfo() {
  return axios({
    url: `${BASE_API}/account/info`,
    method: 'get'
  })
}

/**
 * 找回密码/个人修改登录密码（手机号）
 * @param {Object} data - 找回密码所需的请求数据
 * @param {string} [data.id] - 当返回多个账号需要用户选择时
 * @param {string} [data.mobile] - 用户手机号
 * @param {string} [data.confirmPwd] - 确认密码
 * @param {string} [data.password] - 新密码
 * @param {string} [data.code] - 短信验证码
 * @returns {Promise} 返回axios请求的Promise对象
 */
export function resetPassword(data) {
  return axios({
    url: `${BASE_API}/account/password/retrieve`,
    method: 'post',
    data
  })
}